import React, { useCallback, useEffect, useState } from 'react';
import './ItemHeader.scss';
import LinkProvider from '../../CommonComponents/LinkProvider/LinkProvider';
import ItemFooter from '../../desktop/components/MyAccount/MyDashboard/ItemFooter';

function getDispatchDays(dispatchDate) {
  return Math.floor((new Date() - new Date(dispatchDate)) / (24 * 60 * 60 * 1000));
}

function getProductName(brandName, productTypeValue, modelName) {
  let productName = brandName;
  if (['Eyeglasses', 'Sunglasses'].includes(productTypeValue))
    productName = `${brandName} ${productTypeValue}`;
  else if (productTypeValue === 'Contact Lens') productName = modelName;
  return productName;
}

function goToOrderDetails(id, history) {
  history.push({ pathname: `/sales/order/history/order-detail/${id}`, state: { id } });
}

const packageTypes = [
  'zero_power',
  'single_vision',
  'bifocal',
  'tinted_sv',
  'contact_lens',
  'sunglasses',
];

function ItemHeader(props) {
  const {
    dataLocale,
    dataLocale: { CURRENCY_CODE, MORE_ACTIONS = 'MORE ACTIONS' },
    view,
    orderStatusRedis,
    delivered,
    currencyMark,
    order: {
      id: orderId,
      shippingAddress: { email, firstName, lastName },
    },
    item: {
      productTypeValue,
      sellerLabel,
      amount: { total, currencyCode = 'INR' } = {},
      options = [],
      brandName,
      thumbnail,
      productUrl,
      productId,
      dispatchDate,
      modelName,
    },
    listing,
    history,
    returnConfig,
    orderData,
    returnEligibilityItemDetails,
    classification,
    returnId,
    itemId,
    deliveryDate,
    isReturnCancelled,
    showItemExchangeRefund,
    localeInfo,
  } = props;
  const currencySymbol = currencyCode ? (
    <span>{currencyMark[currencyCode]}</span>
  ) : (
    <span>{currencyMark[CURRENCY_CODE]}</span>
  );
  const customerName = `${firstName} ${lastName}`;
  const [headerData, setHeaderData] = useState({ lensPackage: '', coating: '', dispatchDays: 0 });
  const [itemName] = useState(getProductName(brandName, productTypeValue, modelName));
  useEffect(() => {
    const coating = [];
    const lensPackage = [];
    let type;
    let dispatchDays = 0;
    let deliveryETA = 20;
    for (let i = 0, len = options.length; i < len; i++) {
      type = options[i].type && options[i].type.toLowerCase();
      if (packageTypes.includes(type)) {
        lensPackage.push(options[i].name);
      } else if (type.toLowerCase() === 'coating') {
        coating.push(options[i].name);
      }
    }
    if (dispatchDate) {
      dispatchDays = getDispatchDays(dispatchDate);
    }
    if (orderStatusRedis) {
      deliveryETA = JSON.parse(orderStatusRedis).deliveredETA || 20;
    }
    setHeaderData({ lensPackage, coating, dispatchDays, deliveryETA });
  }, []);
  const { lensPackage, coating, dispatchDays, deliveryETA } = headerData;
  const { HOWS_THE_PRODUCT, WRITE_A_REVIEW } = dataLocale;
  const url = productUrl ? new URL(productUrl) : null;
  let goToOrderDetailsFunc;
  if (listing && view === 'mobile' && returnConfig?.showItemMoreActions) {
    goToOrderDetailsFunc = useCallback(goToOrderDetails.bind(null, orderId, history), []);
  }
  return (
    <div
      className={`item-header ${
        view === 'desktop'
          ? 'padding-l20 padding-r15 padding-t15 padding-b10'
          : 'pd-l15 pd-r15 pd-t15'
      }`}
      data-testid="itemHeader"
    >
      {view !== 'desktop' && (delivered || dispatchDays > deliveryETA) && (
        <div className="item-review display-flex justify-space-between pd-b10 mr-b15">
          <span>{HOWS_THE_PRODUCT}</span>
          <LinkProvider
            aria-label="Click here for write a review"
            className="text-color_link_blue"
            to={{
              pathname: '/customer-feedback',
              search: `?pId=${productId}`,
              state: { name: customerName, email },
            }}
          >
            {WRITE_A_REVIEW}
          </LinkProvider>
        </div>
      )}
      <div className="display-flex justify-content-between">
        <div>
          <a
            className="no-decoration"
            data-testid="goToProductUrl"
            href={url ? url.pathname + url.hash : ''}
            rel="noreferrer"
            target={view === 'desktop' ? '_blank' : '_self'}
          >
            <div className="display-flex">
              <div
                className={`item-img ${
                  view === 'desktop' ? 'desktop' : 'mobile'
                } pd-l5 padding-l5 flex-basis-32`}
              >
                {thumbnail && <img alt="product-img" aria-label="Product Image" src={thumbnail} />}
              </div>
              <div
                className={`info overflow-hidden flex-basis-68 ${
                  view === 'desktop' ? 'align-self-center fs14' : 'fsp14'
                }`}
              >
                <div
                  className={`${
                    view === 'desktop'
                      ? 'fs16 text-color-33 margin-b4'
                      : 'text-color_grey_black mr-b4'
                  }`}
                >
                  {itemName}
                </div>
                {lensPackage &&
                  lensPackage.map((item, index) => (
                    <div
                      key={`${item}_${index}`}
                      className={`${
                        view === 'desktop'
                          ? 'text-color-66 margin-b4'
                          : 'text-color_pale_black mr-b4 '
                      }`}
                      data-testid="lensPackage"
                    >
                      + {item}
                    </div>
                  ))}
                {coating &&
                  coating.map((item, index) => (
                    <div
                      key={`${item}_${index}`}
                      className={`${
                        view === 'desktop'
                          ? 'text-color-66 margin-b4'
                          : 'text-color_pale_black mr-b4'
                      }`}
                      data-testid="coating"
                    >
                      + {item}
                    </div>
                  ))}
                {localeInfo?.countryCode !== 'sg' && sellerLabel && (
                  <div
                    className={`${
                      view === 'desktop'
                        ? 'text-color-grey margin-t4 fs12'
                        : 'text-color_cc mr-t8 fsp12'
                    }`}
                  >
                    {sellerLabel}
                  </div>
                )}
                <div
                  className={`lh-18 ${
                    view === 'desktop'
                      ? 'fw700 text-color-33 fs16 margin-t10 padding-b10'
                      : 'fw500 text-color_grey_black fsp16 mr-t10 pd-b15'
                  }`}
                >
                  {currencySymbol} {total}
                </div>
              </div>
            </div>
          </a>
        </div>
        {showItemExchangeRefund && !orderData?.isInsuranceFlow && (
          <ItemFooter
            classification={classification}
            deliveryDate={deliveryDate}
            history={history}
            isReturnCancelled={isReturnCancelled}
            itemId={itemId}
            orderData={orderData}
            orderId={orderId}
            productId={productId}
            returnConfig={returnConfig}
            returnEligibilityItemDetails={returnEligibilityItemDetails}
            returnId={returnId}
            returnSelection={returnConfig.returnSelection}
          />
        )}
      </div>
      {typeof goToOrderDetailsFunc === 'function' && view === 'desktop' && (
        <div
          aria-label="Click here to see your order details"
          className="mr-t8 mr-b8 text-topaz text-center bg-color_white border-topaz pd-8 bora-4 fw700 fsp14 lh-16 text-uppercase"
          onClick={goToOrderDetailsFunc}
        >
          {MORE_ACTIONS}
        </div>
      )}
    </div>
  );
}

export default ItemHeader;
